module.exports = {
          srcSet: __webpack_public_path__ + "7d05652f10e704c7f34ee0c2443bcb5a-120.png"+" 120w",
          images:[ {path: __webpack_public_path__ + "7d05652f10e704c7f34ee0c2443bcb5a-120.png",width: 120,height: 37}],
          src: __webpack_public_path__ + "7d05652f10e704c7f34ee0c2443bcb5a-120.png",
          toString:function(){return __webpack_public_path__ + "7d05652f10e704c7f34ee0c2443bcb5a-120.png"},
          
          width: 120,
          height: 37
        }